"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M6.67 11H4v2h2.67l1-1zM13 6.67V4h-2v2.67l1 1zm-2 10.66V20h2v-2.67l-1-1zM16.33 12l1 1H20v-2h-2.67z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M9 16.5V22h6v-5.5l-3-3zm4 3.5h-2v-2.67l1-1 1 1zm2-12.5V2H9v5.5l3 3zM11 4h2v2.67l-1 1-1-1zM7.5 9H2v6h5.5l3-3zm-.83 4H4v-2h2.67l1 1zm9.83-4-3 3 3 3H22V9zm3.5 4h-2.67l-1-1 1-1H20z"
}, "1")], 'GamepadTwoTone');